module.exports = __webpack_public_path__ + "img/cgn.2224191f.svg";